<div class="add-container">
  <app-sidenav-header [title]="title"></app-sidenav-header>
  <div class="p-24" class="form-section pr-10">
    <form [formGroup]="createLobForm" class="p-8">

      <div class="flex flex-col mb-16">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{title | uppercase}}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_LOB.LOB_NAME' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <input formControlName="name" placeholder="{{'ADD_LOB.LOB_NAME' | transloco}}" class="fw-500" required>
        <app-error [control]="createLobForm.get('name')"></app-error>
      </div>

      <div class="flex flex-col mb-16">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'LINE_OF_BUSINESS.DISPLAY_NAME' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'LINE_OF_BUSINESS.DISPLAY_NAME' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <input formControlName="displayName" placeholder="{{'LINE_OF_BUSINESS.DISPLAY_NAME' | transloco}}" class="fw-500" required>
        <app-error [control]="createLobForm.get('displayName')"></app-error>
      </div>

      <div class="flex flex-col mb-16">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'LINE_OF_BUSINESS.TAG_LINE' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'LINE_OF_BUSINESS.TAG_LINE' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <input formControlName="tagline" placeholder="{{'LINE_OF_BUSINESS.TAG_LINE' | transloco}}" class="fw-500" required>
        <app-error [control]="createLobForm.get('tagline')"></app-error>
      </div>

      <div class="flex flex-col mb-16">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'LINE_OF_BUSINESS.IMAGE' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'LINE_OF_BUSINESS.IMAGE' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <input formControlName="imageRef" placeholder="{{'LINE_OF_BUSINESS.IMAGE' | transloco}}" class="fw-500" required>
        <app-error [control]="createLobForm.get('imageRef')"></app-error>
      </div>

      <div class="flex flex-col mb-16">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'LINE_OF_BUSINESS.DESCRIPTION' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_LOB.PLACE_HOLDER.DESCRIPTION' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <textarea formControlName="shortDescription" placeholder="{{'ADD_LOB.PLACE_HOLDER.DESCRIPTION' | transloco}}" class="fw-500 text-area" required></textarea>
        <app-error [control]="createLobForm.get('shortDescription')"></app-error>
      </div>
  
    </form>
  </div>

  <div class="footer pt-16" >
    <div class="flex flex-row justify-end gap-x-6">
      <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button class="accent" type="button" (click)="createDeployment()">{{textbutton}}</button>
    </div>
  </div>
</div>
<div class="overlay" *ngIf="isLoading">
  <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
</div>